import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
import {
  GridLayout,
  GridLayoutItem,
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
} from "@progress/kendo-react-grid";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../../components/layout/Loading";
import AlertBox from "../../../components/common/AlertBox";
import { useLocation, useNavigate } from "react-router-dom";
// import moment from "moment";
import { getUpcomingCallsList } from "../services/dashboard.services";
import { useResponsiveJSX } from "../../../_helper/helper";
import TabStripTitle from "../../../components/common/TabStripTitle";
import { FiList } from "react-icons/fi";
import { MdLeaderboard } from "react-icons/md";
import {
  AiOutlineAudio,
  AiOutlineFile,
  AiOutlineFileDone,
  AiOutlinePaperClip,
  AiOutlinePhone,
  AiOutlineTeam,
} from "react-icons/ai";
import { setUpComingCallsTab } from "../dashboardSlice";

const CallsUpcoming = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const FromDate = location.state?.FromDate;
  const ToDate = location.state?.ToDate;
  const type = location?.pathname?.split("/")?.[2] || "";

  const dispatch = useAppDispatch();
  const UpComingCallsTab = useAppSelector(
    (state) => state.dashboard.UpComingCallsTab,
  );

  useEffect(() => {
    const upcommingName = UpComingCallsTab === 0 ? "inquiry" : "lead";
    const payload = {
      UpcomingName: upcommingName,
      FromDate: FromDate && FromDate !== "0" ? FromDate : null,
      ToDate: ToDate && ToDate !== "0" ? ToDate : null,
      IsToday: type === "todaycalls" ? true : false,
      IsMissed: type === "missedcalls" ? true : false,
    };
    dispatch(getUpcomingCallsList(payload));
  }, [UpComingCallsTab]);

  const handleSelect = (e: TabStripSelectEventArguments) => {
    dispatch(setUpComingCallsTab(e?.selected));
  };
  const CloseTaskDialog: React.FC = () => {
    const CloseTask = () => {
      navigate(-1);
    };
    return (
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          style={{ padding: 4, marginTop: 10 }}
          themeColor={"primary"}
          fillMode={"outline"}
          onClick={CloseTask}
        >
          Back
        </Button>
      </div>
    );
  };

  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            {type === "todaycalls"
              ? "Today's Call Follow-ups"
              : type === "upcommingcalls"
                ? "Upcoming Call Follow-ups"
                : type === "missedcalls"
                  ? "Missed Call Follow-ups"
                  : "Call List"}
          </Typography.h4>
        </GridLayoutItem>
        <GridLayoutItem>
          <TabStrip
            className="nb-inquiry-types-tab"
            selected={UpComingCallsTab}
            onSelect={handleSelect}
          >
            <TabStripTab
              title={<TabStripTitle title={"Inquiry"} icon={FiList} />}
            >
              <CallsGridComponent />
            </TabStripTab>
            <TabStripTab
              title={<TabStripTitle title={"Lead"} icon={MdLeaderboard} />}
            >
              <CallsGridComponent />
            </TabStripTab>
          </TabStrip>
        </GridLayoutItem>
        <CloseTaskDialog />
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}
const initialDataState: PageState = { skip: 0, take: 10 };
const CallsGridComponent: React.FC = () => {
  const UpcomingCallsList = useAppSelector(
    (state) => state.dashboard.UpcomingCallsList,
  );
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.dashboard.loading);
  const breakPoint = useResponsiveJSX([1024, 2170, 2514]);
  const dynamicWidth = [150, 200, 250, 300][breakPoint] ?? 300;
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? UpcomingCallsList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      style={props.thProps?.style}
      className={`table-header ${
        props.index === 13 || props.index === 0 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const LeadActivityLogsCommandCell = (props: GridCellProps) => {
    const handleActivityLogs = ({
      LeadID,
      NBInquiryTypeID,
      NBLeadTypeID,
      ActivityLogType,
    }: any) => {
      navigate("/clientform/leadactivitylogs", {
        state: {
          ActivityLog: {
            LeadID,
            NBInquiryTypeID,
            NBLeadTypeID,
            ActivityLogType,
          },
        },
      });
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        <Button
          themeColor={"warning"}
          type="button"
          style={{ margin: "2px" }}
          fillMode="outline"
          size="small"
          title="Notes"
          onClick={() =>
            handleActivityLogs({
              LeadID: props.dataItem?.LeadID,
              NBInquiryTypeID: props.dataItem?.NBInquiryTypeID,
              NBLeadTypeID: props.dataItem?.NBLeadTypeID,
              ActivityLogType: 0,
            })
          }
        >
          <AiOutlineFile />
        </Button>
        <Button
          themeColor={"inverse"}
          style={{ margin: "2px" }}
          type="button"
          fillMode="outline"
          size="small"
          title="Tasks"
          onClick={() =>
            handleActivityLogs({
              LeadID: props.dataItem?.LeadID,
              NBInquiryTypeID: props.dataItem?.NBInquiryTypeID,
              NBLeadTypeID: props.dataItem?.NBLeadTypeID,
              ActivityLogType: 1,
            })
          }
        >
          <AiOutlineFileDone />
        </Button>
        <Button
          themeColor={"secondary"}
          type="button"
          style={{ margin: "2px" }}
          fillMode="outline"
          size="small"
          title="Calls"
          onClick={() =>
            handleActivityLogs({
              LeadID: props.dataItem?.LeadID,
              NBInquiryTypeID: props.dataItem?.NBInquiryTypeID,
              NBLeadTypeID: props.dataItem?.NBLeadTypeID,
              ActivityLogType: 2,
            })
          }
        >
          <AiOutlinePhone />
        </Button>
        <Button
          themeColor={"success"}
          type="button"
          fillMode="outline"
          style={{ margin: "2px" }}
          size="small"
          title="Meetings"
          onClick={() =>
            handleActivityLogs({
              LeadID: props.dataItem?.LeadID,
              NBInquiryTypeID: props.dataItem?.NBInquiryTypeID,
              NBLeadTypeID: props.dataItem?.NBLeadTypeID,
              ActivityLogType: 3,
            })
          }
        >
          <AiOutlineTeam />
        </Button>
        <Button
          themeColor={"tertiary"}
          type="button"
          style={{ margin: "2px" }}
          fillMode="outline"
          size="small"
          title="Attachment"
          onClick={() =>
            handleActivityLogs({
              LeadID: props.dataItem?.LeadID,
              NBInquiryTypeID: props.dataItem?.NBInquiryTypeID,
              NBLeadTypeID: props.dataItem?.NBLeadTypeID,
              ActivityLogType: 4,
            })
          }
        >
          <AiOutlinePaperClip />
        </Button>
        <Button
          themeColor={"error"}
          type="button"
          style={{ margin: "2px" }}
          fillMode="outline"
          size="small"
          title="Recording"
          onClick={() =>
            handleActivityLogs({
              LeadID: props.dataItem?.LeadID,
              NBInquiryTypeID: props.dataItem?.NBInquiryTypeID,
              NBLeadTypeID: props.dataItem?.NBLeadTypeID,
              ActivityLogType: 5,
            })
          }
        >
          <AiOutlineAudio />
        </Button>
      </td>
    );
  };

  const CustomCell = (props: any) => {
    return (
      <td
        style={{ ...props.style }}
        {...props.tdProps}
        colSpan={1}
        className={`table-cell ${props.className}`}
      >
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );
  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {UpcomingCallsList && UpcomingCallsList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          className="responsive-table"
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(UpcomingCallsList, filter).slice(
                  page.skip,
                  page.take + page.skip,
                )
              : UpcomingCallsList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={UpcomingCallsList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="LeadName"
            title="Client Name"
            width={dynamicWidth}
            locked
          />
          <Column field="GroupCode" title="Group Code" width={dynamicWidth} />
          <Column field="Subject" title="Subject" width={dynamicWidth} />
          <Column
            field="CallPurpose"
            title="Call Purpose"
            width={dynamicWidth}
          />
          <Column field="Agenda" title="Agenda" width={dynamicWidth} />
          <Column field="CallResult" title="Call Result" width={dynamicWidth} />
          <Column field="CallType" title="Call Type" width={dynamicWidth} />
          <Column field="CallStatus" title="Call Status" width={dynamicWidth} />
          <Column field="CallDate" title="Call Date" width={dynamicWidth} />
          <Column
            field="FollowupDate"
            title="Followup Date"
            width={dynamicWidth}
          />
          <Column
            field="FollowupTime"
            title="Followup Time"
            width={dynamicWidth}
          />
          <Column
            field="FollowupNotes"
            title="Followup Notes"
            width={dynamicWidth}
          />
          <Column
            field="Description"
            title="Description"
            width={dynamicWidth}
          />
          <Column
            field="ID"
            title="Activity Logs"
            cell={LeadActivityLogsCommandCell}
            width={"150px"}
            locked={true}
            filterable={false}
          />
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default CallsUpcoming;
